export enum NotificationStatus {
  unViewed = 1,
  viewed,
  delete,
}
